import React from "react";
import "../../styles/Offerings/Offering.css";
import "../../styles/Offerings/OfferingBanner.css";

const Banner = ({data}) => {
  return (
    <div className="offering-banner-container">
      <div className="offering-banner-innercontainer">
        <div>
          <div className="offering-banner-title">{data.title || "Find the Right Plan For Your Startup"}</div>
          <div className="offering-banner-desc">{data.desc || "Turn Your Startup Dream Into Reality In 2025!"}</div>
        </div>
        <div>
          <img className="offering-img" src={data.src} alt="offering-icon" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
